<template>
    <v-layout :class="layoutClass"
              style="min-height: 28px;color: black !important;">
        <span v-if="!removeLabel"
              :class="{'form-field__label-h':!vertical,'form-field__label-v':vertical}"
              :style="{minWidth: _labelWidth+'px',fontWeight:'bold'}">
            <span v-if="!hideLabel">
            <slot name="label">
                <slot name="label-prepend"></slot>{{label}}<slot name="label-append"></slot> :
                </slot>
            </span>
        </span>
        <v-layout class="flex-row">
            <v-layout class="flex-grow-0 flex-shrink-0" :style="{width:_fieldWidth+'px',maxWidth: _fieldWidth+'px'}">
                <slot name="content">
                    <v-text-field v-if="!readonly" :readonly="readonly" :autofocus="autofocus" autocomplete="off" class="form-input__border"
                                  solo
                                  flat
                                  ref="self"
                                  :type="password?'password':'text'"
                                  :placeholder="placeholder"
                                  :disabled="disableEnable"
                                  hide-details single-line dense v-model="textContent"
                                  @keydown="onKeydown"
                                  @change="onchange">
                    </v-text-field>
                    <span class="readonly-field" v-else>{{textContent}}</span>
                </slot>
            </v-layout>
            <v-tooltip v-if="tip" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon small>
                        <v-icon small>mdi-help-circle-outline</v-icon>
                    </v-btn>
                </template>
                <span>{{tip}}</span>
            </v-tooltip>
            <slot name="append"></slot>
        </v-layout>
    </v-layout>
</template>

<script>
    export default {
        name: "FormField",
        props: {
            small: {
                type: Boolean,
                default: false
            },
            xSmall: {
                type: Boolean,
                default: false
            },
            xxSmall: {
                type: Boolean,
                default: false
            },
            middle: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            xLarge: {
                type: Boolean,
                default: false
            },
            xxLarge: {
                type: Boolean,
                default: false
            },
            label: {
                type: String
            },
            disable: {
                type: Boolean,
                default: false,
            },
            value: {},
            readonly: {
                type: Boolean,
                default: false
            },
            text: {},
            placeholder: {type: String},
            autofocus: {
                type: Boolean,
                default: false
            },
            labelWidth: {
                type: Number
            },
            fieldWidth: {
                type: Number
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            removeLabel: {
                type: Boolean,
                default: false
            },
            tip: {
                type: String
            },
            password: {
                type: Boolean,
                default: false
            },
            horizontal: {
                type: Boolean,
                default: true
            },
            vertical: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                _labelWidth: 80,
                _fieldWidth: 100,
                textContent: null,
                horizontalClass: 'form-input-text d-flex flex-row  align-center mb-1',
                verticalClass: 'form-input-text d-flex flex-column  align-start mb-1'
            }
        },
        computed: {
            disableEnable: {
                get() {
                    return this.disable;
                }
            },
            layoutClass: function () {
                return this.vertical ? this.verticalClass : this.horizontalClass;
            }
        },
        watch: {
            value(val) {
                this.textContent = val;
            },
            text(val) {
                this.textContent = val;
            }
        },
        created() {
            this._labelWidth = this.$tool.labelWidth(this.labelWidth, this.xxSmall, this.xSmall, this.small, this.middle, this.large, this.xLarge, this.xxLarge);
            this._fieldWidth = this.$tool.fieldWidth(this.fieldWidth, this.xxSmall, this.xSmall, this.small, this.middle, this.large, this.xLarge, this.xxLarge);
            this.textContent = this.value;
            if (this.textContent == null || this.textContent == undefined) {
                this.textContent = this.text;
            }

        },
        methods: {
            onchange(val) {
                this.$emit('input', val);
                this.$emit('change', val);
            },
            onKeydown(e) {
                if (e.keyCode === 13) {
                    this.$emit('enter', e);
                }
            },
            clear() {
                this.$refs.self.clearableCallback()
            }
        }
    }
</script>
